<template>
  <header id="header" class="header-bg">
    <div class="header-content">
      <div style="display: flex; align-items: center; gap: 10px">
        <div class="logo-container">
          <img src="@/assets/image/home-logo.png">
        </div>
        <div class="language_view">
          <img src="@/assets/image/i18n.png">
          <select :value="generationLanguage()" @change="handleLanguageChange">
            <option value="zh">简体中文</option>
            <option value="en">English</option>
            <option value="es">Español</option>
            <option value="id">Bahasa Indonesia</option>
            <option value="ja">日本語</option>
            <option value="ko">한국어</option>
            <option value="ms">Bahasa Melayu</option>
            <option value="pt">Português</option>
            <option value="th">ไทย</option>
            <option value="vi">Tiếng Việt</option>
            <option value="ar">العربية</option>
          </select>
        </div>
      </div>
      <nav>
        <a href="#">{{ $t('home') }}</a>
        <a href="javascript:void(0)" @click="handleToComicSeries">{{ $t('comic_series') }}</a>
        <a href="javascript:void(0)" @click="handleToPrivacy">{{
          $t('privacy_policy')
        }}</a>
        <a href="javascript:void(0)" @click="handleToUserAgreement">{{
          $t('user_agreement')
        }}</a>
      </nav>
    </div>
  </header>
</template>

<script>
import { generationLanguage, switchLanguage } from '@/lang/index'
export default {
  name: 'HeaderCom',
  methods: {
    generationLanguage,
    handleToPrivacy() {
      this.$router.push({ path: '/privacy' })
    },
    handleToUserAgreement() {
      this.$router.push({ path: '/user-agreement' })
    },
    handleToComicSeries() {
      this.$router.push({ path: '/comic-series' })
    },
    handleToPaymentTerms() {
      this.$router.push({ path: '/payment-terms' })
    },
    handleToMerchantAgreementTermination() {
      this.$router.push({ path: '/merchant-agreement-termination' })
    },
    handleToEmailConfirmation() {
      this.$router.push({ path: '/email-confirmation' })
    },
    handleToBillingStatement() {
      this.$router.push({ path: '/billing-statement' })
    },
    handleLanguageChange(e) {
      switchLanguage(e.target.value)
      localStorage.setItem('CURRENT_LANGUAGE', e.target.value)
    },
  },
}
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
}
.header-bg {
  .header-content {
    width: calc(100% - 60px);
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    padding: 8px 30px;
    justify-content: space-between;
    .logo-container {
      display: flex;
      align-items: center;
      img {
        width: 120px;
      }
    }
    nav {
      margin-left: 165px;
      display: flex;
      align-items: center;
      a {
        margin-right: 32px;
        color: #fff;
        font-size: 20px;
        font-family: Inter;
        text-decoration: none;
        @media screen and (max-width: 768px) {
          font-size: 14px !important;
        }
      }
    }
  }
}
.header-bg-black {
  background-color: #000;
}
.language_view {
  display: flex;
  align-items: center;
  gap: 6px;
  img {
    width: 24px;
    height: 24px;
  }
  select {
    background-color: rgba(0, 0, 0, 0);
    color: #fff;
  }
  select option {
    background-color: transparent;
    color: #000; /* option 文字颜色 */
  }
}
</style>
